<div *ngIf="loadingData.fetchAccounts && loadingData.fetchMessages" style="margin: 10px">
	<mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div *ngIf="!loadingData.fetchAccounts && !loadingData.fetchMessages">
	<mat-sidenav-container *ngIf="!messagesOnly">
		<div class="main-summary-column" *ngIf="!messagesOnly">
			<div class="ahs-ion-item-title" style="padding-left: 15px; padding-bottom: 5px">
				<div class="ahs-ion-item-row-title">
					<span class="ahs-ion-item-icon">
						<fa-icon [icon]="$any(faIcons.faComment)"></fa-icon>
					</span>
					<span class="ahs-ion-item-content">
						<div *ngIf="!showPhoneLink" class="ahs-ion-item-details">
							{{ 'DESCRIPTION' | translate }}
						</div>
						<div *ngIf="showPhoneLink" class="ahs-ion-item-details">
							{{ 'MESSAGING_PHONE_TEXT_1' | translate }}
							<span>
								<a href="{{ 'MESSAGING_PHONE_NUMBER_LINK' | translate }}">
									{{ 'MESSAGING_PHONE_NUMBER' | translate }}
								</a>
							</span>
							{{ 'MESSAGING_PHONE_TEXT_2' | translate }}
						</div>
					</span>
					<span class="button-container">
						<button mat-raised-button extended (click)="showNewMessageDialog()" class="new-message-btn">
							<mat-icon>add</mat-icon>
							{{ 'NEW_MESSAGE' | translate }}
						</button>
					</span>
				</div>
			</div>
			<div class="name-panel-column" style="margin-bottom: 5px">
				<div
					style="
						height: 100px;
						padding: 15px;
						border-top: solid 1px #ddd;
						border-bottom: solid 1px #ddd;
						background: #fff;
					"
				>
					<mat-form-field appearance="outline" style="width: 100%">
						<mat-label>{{ 'SEARCH_MESSAGES' | translate }}</mat-label>
						<input
							id="secure-messaging-filter-input"
							matInput
							[(ngModel)]="filterValue"
							(keyup)="filterMessages()"
							maxlength="100"
						/>
					</mat-form-field>
				</div>
			</div>

			<message-panel
				[conversations]="filteredConversations"
				[selectedId]="selectedConversationId"
				[showDisplayName]="showDisplayName"
				(selectedConversationId)="goToMessage($event)"
			>
			</message-panel>
		</div>

		<mat-sidenav
			opened
			mode="side"
			position="end"
			[(opened)]="messageOpen"
			[mode]="sideNavType"
			[autoFocus]="isAutoFocus"
			class="side-nav"
			style="background: #eee"
		>
			<div style="display: flex; flex-flow: column">
				<div
					style="
						width: 100%;
						display: flex;
						flex-flow: row;
						padding: 20px 10px 12px 15px;
						justify-content: space-between;
					"
					*ngIf="!messagesOnly"
				>
					<div>
						<mat-icon style="cursor: pointer; color: #2b78e4" (click)="toggleMessageView()"
							>arrow_back_ios</mat-icon
						>
						<div
							tabindex="0"
							(keyup.enter)="toggleMessageView()"
							(click)="toggleMessageView()"
							style="margin-top: 5px; float: right; font-size: 16px; cursor: pointer"
						>
							{{ 'VIEW_MESSAGES' | translate }}
						</div>
					</div>
					<div>
						<button
							id="secure-messaging-menu2-button"
							style="box-shadow: none; margin-top: 0px; margin-right: 5px"
							mat-mini-fab
							[matMenuTriggerFor]="menu2"
							layout-align="end center"
						>
							<mat-icon aria-hidden="false" aria-label="Example home icon">more_vert</mat-icon>
						</button>
						<mat-menu #menu2="matMenu">
							<div *ngIf="selectedConversation?.conversationStatus.codeName.toUpperCase() == 'OPEN'">
								<button
									id="secure-messaging-mark-closed-button"
									mat-menu-item
									(click)="showCloseMessageWarningDialog()"
								>
									<mat-icon aria-hidden="false" aria-label="Example home icon">close</mat-icon>
									{{ 'MARK_CLOSED' | translate }}
								</button>
							</div>
							<div *ngIf="selectedConversation?.conversationStatus.codeName.toUpperCase() == 'CLOSED'">
								<button
									id="secure-messaging-reopen-button"
									mat-menu-item
									(click)="markConversationOpen()"
								>
									<mat-icon aria-hidden="false" aria-label="Example home icon">check</mat-icon>
									{{ 'REOPEN' | translate }}
								</button>
							</div>
						</mat-menu>
					</div>
				</div>

				<div
					*ngIf="!messagesOnly"
					style="
						width: 100%;
						border-top: 1px solid #ddd;
						border-bottom: 1px solid #ddd;
						display: flex;
						flex-flow: row;
						align-items: center;
						margin-bottom: 10px;
						padding-top: 10px;
						padding-bottom: 10px;
						background: #fff;
					"
				>
					<div
						style="
							display: flex;
							flex-flow: column;
							border-radius: 10px 0 0 10px;
							padding-left: 15px;
							padding-right: 5px;
						"
					>
						<fa-icon
							*ngIf="selectedConversation?.conversationStatus.codeName.toUpperCase() == 'OPEN'"
							[icon]="$any(faIcons.faCommentDots)"
							style="font-size: 30px; color: #76a5af"
						></fa-icon>
						<fa-icon
							*ngIf="selectedConversation?.conversationStatus.codeName.toUpperCase() == 'CLOSED'"
							[icon]="$any(faIcons.faCommentCheck)"
							style="font-size: 30px; color: #ababab"
						></fa-icon>
					</div>

					<div style="display: flex; flex-flow: column; margin-left: 10px; font-size: 14px; overflow: hidden">
						<div
							style="
								font-size: 16px;
								overflow: hidden;
								white-space: nowrap;
								text-overflow: ellipsis;
								padding-right: 20px;
							"
						>
							{{ selectedConversation?.conversationCategory?.languageKey | translate }}
						</div>
						<div>
							{{ 'DATE' | translate }}:
							{{ selectedConversation?.messages[0].createdDate | date: 'M/d/yyyy' }}
						</div>
						<div>
							{{ 'STATUS' | translate }}:
							{{ selectedConversation?.conversationStatus?.codeName?.toUpperCase() | translate }}
						</div>
						<div *ngIf="showDisplayName">
							{{ 'ENROLLMENT_MEMBER' | translate }}: {{ selectedConversation?.displayName }}
						</div>
					</div>
				</div>

				<!--<chat-panel [selectedConversation]="selectedConversation" #chatpanel></chat-panel>-->

				<div
					style="
						width: 100%;
						display: flex;
						flex-flow: column;
						align-items: center;
						min-height: 200px;
						border-top: 1px solid #ddd;
						border-bottom: 1px solid #ddd;
						padding-top: 20px;
						background: #fff;
					"
					*ngIf="!messagesOnly"
				>
					<div
						*ngFor="let msg of selectedConversation?.messages"
						style="width: 100%; display: flex; flex-flow: column; align-items: center"
					>
						<div [ngClass]="{ 'message-right': msg.webUser, 'message-left': msg.ahsUser }" style="">
							<div>
								<span style="">{{ msg.webUser }} {{ msg.ahsUser | translate }}</span>
								<span style="color: #666"> - {{ msg.createdDate | date: 'M/d/yyyy, h:mm a' }}</span>
							</div>
							<mat-card
								appearance="outlined"
								class="keep-whitespace"
								[ngClass]="{ 'message-detail-right': msg.webUser, 'message-detail-left': msg.ahsUser }"
								>{{ msg.text }}</mat-card
							>
							<div></div>
						</div>
					</div>

					<div
						class=""
						[formGroup]="newMessageForm"
						novalidate
						#myNewMessageForm
						style="width: 100%; padding: 20px"
						*ngIf="selectedConversation?.conversationStatus?.codeName.toUpperCase() == 'OPEN'"
					>
						<mat-form-field
							class=""
							tabindex="-1"
							appearance="outline"
							style="width: 100%; display: flex; flex-flow: column; align-items: flex-start"
						>
							<textarea
								id="secure-messaging-message-textarea"
								#msgTextarea
								maxlength="1000"
								matInput
								formControlName="message"
								style="margin-right: 10px"
								placeholder="{{ 'TYPE_MESSAGE_HERE' | translate }}"
							></textarea>
							<mat-hint align="end">{{ msgTextarea.value?.length || 0 }} / 1000</mat-hint>
							<mat-error *ngIf="newMessageForm.controls['message']?.invalid" class="large-text">{{
								'MESSAGE_ERROR' | translate
							}}</mat-error>
							<button
								id="secure-messaging-send-button"
								*ngIf="!loadingData.sendingMessage"
								mat-mini-fab
								style="
									align-self: flex-end;
									background-color: var(--ht-app-primary, var(--ion-color-primary));
									color: #fdfefe;
									box-shadow: none;
								"
								(click)="sendMessage()"
							>
								<mat-icon style="margin-left: 3px; margin-top: -2px" aria-label="Send Message"
									>send</mat-icon
								>
							</button>
							<mat-spinner *ngIf="loadingData.sendingMessage" [diameter]="36"></mat-spinner>
						</mat-form-field>
					</div>
					<div
						style="display: flex; flex-flow: column; align-items: center; width: 100%"
						*ngIf="selectedConversation?.conversationStatus?.codeName?.toUpperCase() == 'CLOSED'"
					>
						<mat-card
							appearance="outlined"
							style="
								display: flex;
								flex-flow: row;
								align-items: center;
								justify-content: center;
								width: 70%;
							"
							class="closed-message message-detail-left"
						>
							{{ 'MARKED_CLOSED_BY' | translate }} {{ selectedConversation?.displayUserCompletedBy }}
							{{ 'AT' | translate }} {{ selectedConversation?.modifiedDate | date: 'M/d/yyyy' }}
						</mat-card>
						<div
							style="
								width: 100%;
								height: 60px;
								display: flex;
								flex-flow: row;
								align-items: center;
								justify-content: center;
							"
							class="light-grey-background make-it-blue"
						>
							<div style="">{{ 'CANNOT_REPLY' | translate }}</div>
						</div>
					</div>
					<div id="bottomAnchor"></div>
				</div>
			</div>
		</mat-sidenav>
	</mat-sidenav-container>

	<div
		style="
			width: 100%;
			display: flex;
			flex-flow: column;
			align-items: center;
			min-height: 200px;
			border-top: 1px solid #ddd;
			border-bottom: 1px solid #ddd;
			padding-top: 20px;
			background: #fff;
		"
		*ngIf="messagesOnly"
	>
		<div
			*ngFor="let msg of selectedConversation?.messages"
			style="width: 100%; display: flex; flex-flow: column; align-items: center"
		>
			<div [ngClass]="{ 'message-right': msg.webUser, 'message-left': msg.ahsUser }" style="">
				<div>
					<span style="">{{ msg.webUser }} {{ msg.ahsUser | translate }}</span>
					<span style="color: #666"> - {{ msg.createdDate | date: 'M/d/yyyy, h:mm a' }}</span>
				</div>
				<mat-card
					appearance="outlined"
					class="keep-whitespace"
					[ngClass]="{ 'message-detail-right': msg.webUser, 'message-detail-left': msg.ahsUser }"
					>{{ msg.text }}</mat-card
				>
				<div></div>
			</div>
		</div>

		<div
			class=""
			[formGroup]="newMessageForm"
			novalidate
			#myNewMessageForm
			style="width: 100%; padding: 20px"
			*ngIf="selectedConversation?.conversationStatus?.codeName.toUpperCase() == 'OPEN'"
		>
			<mat-form-field
				class=""
				tabindex="-1"
				appearance="outline"
				style="width: 100%; display: flex; flex-flow: row; align-items: flex-start"
			>
				<textarea
					id="secure-messaging-messagesOnly-message-textarea"
					#msgTextarea
					maxlength="1000"
					matInput
					formControlName="message"
					style="margin-right: 10px"
					placeholder="{{ 'TYPE_MESSAGE_HERE' | translate }}"
				></textarea>
				<mat-hint align="end">{{ msgTextarea.value?.length || 0 }} / 1000</mat-hint>
				<mat-error *ngIf="newMessageForm.controls['message']?.invalid" class="large-text">{{
					'MESSAGE_ERROR' | translate
				}}</mat-error>
				<button
					id="secure-messaging-messagesOnly-send-button"
					*ngIf="!loadingData.sendingMessage"
					mat-mini-fab
					style="align-self: flex-end; background-color: #2b78e4; box-shadow: none"
					(click)="sendMessage()"
				>
					<mat-icon style="margin-left: 3px; margin-top: -2px" aria-label="Send Message">send</mat-icon>
				</button>
				<mat-spinner *ngIf="loadingData.sendingMessage" [diameter]="36"></mat-spinner>
			</mat-form-field>
		</div>
		<div
			style="display: flex; flex-flow: column; align-items: center; width: 100%"
			*ngIf="selectedConversation?.conversationStatus?.codeName?.toUpperCase() == 'CLOSED'"
		>
			<mat-card
				appearance="outlined"
				style="display: flex; flex-flow: row; align-items: center; justify-content: center; width: 70%"
				class="closed-message message-detail-left"
			>
				{{ 'MARKED_CLOSED_BY' | translate }} {{ selectedConversation?.displayUserCompletedBy }}
				{{ 'AT' | translate }} {{ selectedConversation?.modifiedDate | date: 'M/d/yyyy' }}
			</mat-card>
			<div
				style="
					width: 100%;
					height: 60px;
					display: flex;
					flex-flow: row;
					align-items: center;
					justify-content: center;
				"
				class="light-grey-background make-it-blue"
			>
				<div style="">{{ 'CANNOT_REPLY' | translate }}</div>
			</div>
		</div>
		<div id="bottomAnchor"></div>
	</div>
</div>
